/*
 * sidebar-options
 */
import type { AuthUser } from "@emr/types"
import type { ReactNode } from "react"
import { SidebarOptionsItem } from "./sidebar-options-item"
import { SidebarOptionsItemMenu } from "./sidebar-options-item-menu"

interface SidebarOptionsProps {
	getSidebarMenuList: (user?: AuthUser | null, devMode?: boolean, flags?: any) => any[]
	bottomContent?: ReactNode
	user?: AuthUser | null
	devMode?: boolean
	flags?: any
	children?: ReactNode
	className?: string
}

export function SidebarOptions({
	getSidebarMenuList,
	user,
	devMode,
	flags,
}: SidebarOptionsProps) {
	const menuList = getSidebarMenuList(user, devMode, flags)

	return menuList.map((content: any, index: number) => (
		<SidebarOptionsItem groupLabel={content.groupLabel} key={index}>
			{content.menus.map(
				({ to, label, icon: Icon, submenus, badge }: any, index: number) => (
					<SidebarOptionsItemMenu
						to={to}
						label={label}
						submenus={submenus}
						badge={badge}
						Icon={<Icon className={"size-4"} />}
						key={index}
					/>
				),
			)}
		</SidebarOptionsItem>
	))
}
